// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as BookRouteImport } from './routes/book'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DeliveryRouteImport } from './routes/delivery'
import { Route as ExoticCarRentalVancouverRouteImport } from './routes/exotic-car-rental-vancouver'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as LuxuryCarRentalVancouverRouteImport } from './routes/luxury-car-rental-vancouver'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RatesRouteImport } from './routes/rates'
import { Route as RentOutYourCarRouteImport } from './routes/rent-out-your-car'
import { Route as ReserveRouteImport } from './routes/reserve'
import { Route as ShareReviewRouteImport } from './routes/share-review'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as WeddingCarRentalVancouverRouteImport } from './routes/wedding-car-rental-vancouver'
import { Route as WhyUsRouteImport } from './routes/why-us'
import { Route as YvrAirportCarRentalRouteImport } from './routes/yvr-airport-car-rental'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as FleetIndexRouteImport } from './routes/fleet/index'
import { Route as FleetSlugRouteImport } from './routes/fleet/$slug'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AuthenticatedAdminReferrersRouteImport } from './routes/_authenticated/admin.referrers'
import { Route as AuthenticatedAdminSubmissionsRouteImport } from './routes/_authenticated/admin.submissions'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DeliveryRoute = DeliveryRouteImport.update({
            id: '/delivery',path: '/delivery',getParentRoute: () => rootRouteImport
          })
const ExoticCarRentalVancouverRoute = ExoticCarRentalVancouverRouteImport.update({
            id: '/exotic-car-rental-vancouver',path: '/exotic-car-rental-vancouver',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const LuxuryCarRentalVancouverRoute = LuxuryCarRentalVancouverRouteImport.update({
            id: '/luxury-car-rental-vancouver',path: '/luxury-car-rental-vancouver',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RatesRoute = RatesRouteImport.update({
            id: '/rates',path: '/rates',getParentRoute: () => rootRouteImport
          })
const RentOutYourCarRoute = RentOutYourCarRouteImport.update({
            id: '/rent-out-your-car',path: '/rent-out-your-car',getParentRoute: () => rootRouteImport
          })
const ReserveRoute = ReserveRouteImport.update({
            id: '/reserve',path: '/reserve',getParentRoute: () => rootRouteImport
          })
const ShareReviewRoute = ShareReviewRouteImport.update({
            id: '/share-review',path: '/share-review',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const WeddingCarRentalVancouverRoute = WeddingCarRentalVancouverRouteImport.update({
            id: '/wedding-car-rental-vancouver',path: '/wedding-car-rental-vancouver',getParentRoute: () => rootRouteImport
          })
const WhyUsRoute = WhyUsRouteImport.update({
            id: '/why-us',path: '/why-us',getParentRoute: () => rootRouteImport
          })
const YvrAirportCarRentalRoute = YvrAirportCarRentalRouteImport.update({
            id: '/yvr-airport-car-rental',path: '/yvr-airport-car-rental',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const FleetIndexRoute = FleetIndexRouteImport.update({
            id: '/fleet/',path: '/fleet/',getParentRoute: () => rootRouteImport
          })
const FleetSlugRoute = FleetSlugRouteImport.update({
            id: '/fleet/$slug',path: '/fleet/$slug',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminReferrersRoute = AuthenticatedAdminReferrersRouteImport.update({
            id: '/admin/referrers',path: '/admin/referrers',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminSubmissionsRoute = AuthenticatedAdminSubmissionsRouteImport.update({
            id: '/admin/submissions',path: '/admin/submissions',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminReferrersRoute: AuthenticatedAdminReferrersRoute,AuthenticatedAdminSubmissionsRoute: AuthenticatedAdminSubmissionsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,BlogRoute: BlogRouteWithChildren,BookRoute: BookRoute,ContactRoute: ContactRoute,DeliveryRoute: DeliveryRoute,ExoticCarRentalVancouverRoute: ExoticCarRentalVancouverRoute,FaqRoute: FaqRoute,LuxuryCarRentalVancouverRoute: LuxuryCarRentalVancouverRoute,PartnersRoute: PartnersRoute,PrivacyRoute: PrivacyRoute,RatesRoute: RatesRoute,RentOutYourCarRoute: RentOutYourCarRoute,ReserveRoute: ReserveRoute,ShareReviewRoute: ShareReviewRoute,TermsRoute: TermsRoute,ThankYouRoute: ThankYouRoute,WeddingCarRentalVancouverRoute: WeddingCarRentalVancouverRoute,WhyUsRoute: WhyUsRoute,YvrAirportCarRentalRoute: YvrAirportCarRentalRoute,FleetSlugRoute: FleetSlugRoute,FleetIndexRoute: FleetIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)